import Axios from 'axios';
import { notifyForbidden } from '../api/configureApi';

const baseURL = process.env.REACT_APP_API_URL;

const API_URL = `${baseURL}/`;
const axios = Axios.create({});

// Report 403s to the same app-wide access-denied handler the generated client uses. This instance
// is a separate axios with its own interceptor chain, so without this the endpoints that can't go
// through the generated client (SSE streams, multipart uploads) would still fall back to the old
// generic-toast-over-a-broken-page behavior. Errors are re-rejected untouched — this only
// observes, so every existing call-site catch still runs exactly as before.
axios.interceptors.response.use(
    response => response,
    error => {
        if (error?.response?.status === 403) {
            notifyForbidden(error.response?.config?.url ?? error.config?.url);
        }
        return Promise.reject(error);
    }
);

// Get user's timezone for server date calculations
const getTimezone = () => {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (e) {
        return 'Asia/Jerusalem'; // fallback
    }
};

const httpService = {

    get(endpoint, data, token) {
        return ajax(endpoint, 'GET', data, token);
    },
    post(endpoint, data, token) {
        return ajax(endpoint, 'POST', data, token);
    },
    put(endpoint, data, token) {
        return ajax(endpoint, 'PUT', data, token);
    },
    patch(endpoint, data, token) {
        return ajax(endpoint, 'PATCH', data, token);
    },
    delete(endpoint, data, token) {
        return ajax(endpoint, 'DELETE', data, token);
    }
};

export default httpService;

async function ajax(endpoint, method = 'get', data = null, token = null) {
    const res = axios({
        url: `${API_URL}${endpoint}`,
        method,
        data,
        headers: {
            Authorization: `Bearer ${token}`,
            'X-Timezone': getTimezone(),
        },
    });
    return res;
}
